// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__3zQ1k","loaderOuter":"PageOverlayLoader_loaderOuter__39a0T"};